import { FC } from 'react';
// Interfaces
import { IconSvgProps } from '@utmb/types/icons';

const InfoPoint: FC<IconSvgProps> = ({ color, clss, width, height }) => {
    return (
        <svg className={clss} width={width} height={height} viewBox="0 0 43.45 43.45">
            <g>
                <path fill={color} d="M21.64,13.01c1.41,0,2.29-.96,2.25-2.17,0-1.25-.84-2.21-2.17-2.21s-2.21.96-2.21,2.21.88,2.17,2.13,2.17Z"/>
                <rect fill={color} x="19.96" y="15.37" width="3.54" height="19.44"/>
                <path fill={color} d="M21.72,0C9.74,0,0,9.74,0,21.72c0,6.6,2.96,12.51,7.62,16.5l1.36-1.29c-4.34-3.65-7.11-9.11-7.11-15.21C1.86,10.77,10.77,1.86,21.72,1.86s19.86,8.91,19.86,19.86-8.91,19.86-19.86,19.86c-4.17,0-8.04-1.3-11.24-3.5l-1.38,1.3c3.56,2.55,7.92,4.06,12.62,4.06,11.98,0,21.72-9.74,21.72-21.72S33.7,0,21.72,0Z"/>
            </g>
        </svg>
    );
};

export default InfoPoint;
